// credit.stats.dto.ts
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const creditByUserSchema = z.object({
  userId: z.string(),
  name: z.string(),
  total: z.number(),
  remain: z.number(),
});

export const creditStatsSchema = z.object({
  totalDistributed: z.number(),
  totalRemaining: z.number(),
  totalConsumed: z.number(),
  byUser: z.array(creditByUserSchema),
});

export class CreditStatsDto extends createZodDto(creditStatsSchema) {}
